import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from "react-router-dom";

import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle.jsx";

class Tasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stockHist: []
    };
  }
  componentDidMount() {
    this.props.stockHistory.forEach(each => {
      if (
        each.updated_quantity !== null &&
        each.updated_quantity !== each.previous_quantity
      ) {
        this.state.stockHist.push(each);
        this.setState({
          stockHist: this.state.stockHist
        });
      }
    });
  }
  render() {
    const { stockHist } = this.state;

    const ordersList =
      stockHist.length > 0 &&
      stockHist.map(eachHistory => {
        return (
          <tr>
            <td>
              {eachHistory.order ? (
                <Link to={`/orders/${eachHistory.order}`}>
                  {eachHistory.order_id}
                </Link>
              ) : (
                "N/A"
              )}
            </td>
            <td className="text-center">
              {eachHistory.previous_quantity === null
                ? "N/A"
                : eachHistory.previous_quantity}
            </td>
            <td className="text-center">
              {eachHistory.updated_quantity === null
                ? "N/A"
                : eachHistory.updated_quantity}
            </td>
            <td>{eachHistory.updated_by}</td>
            <td>{eachHistory.created_on}</td>
          </tr>
        );
      });
    return (
      <>
        {stockHist.length > 0 ? (
          <div className="header-static">
            <div className="table-header">
              <table>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th className="text-center">Previous Qty</th>
                    <th className="text-center">Updated Qty</th>
                    <th>Updated By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>{ordersList}</tbody>
              </table>
            </div>
            <div className="tableScroll">
              <table className="table-body">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th className="text-center">Previous Qty</th>
                    <th className="text-center">Updated Qty</th>
                    <th>Updated By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>{ordersList}</tbody>
              </table>
            </div>
          </div>
        ) : (
          <p className="noData">
            <span>
              <i className="fas fa-coins" />
              No Stock History For This Product
            </span>
          </p>
        )}
      </>
    );
  }
}

Tasks.propTypes = {
  orders: PropTypes.array
};

export default withStyles(tasksStyle)(Tasks);
